export { default as createEmojiPlugin } from './plugin/createEmojiPlugin';
export { EmojiStringKeys } from './type/EmojiStringKeys';
